import React from "react";

const Instagram = ({ ...rest }) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="Instagram">
                <path
                    id="Icon"
                    d="M17.5 6.60254H17.51M7 2.10254H17C19.7614 2.10254 22 4.34112 22 7.10254V17.1025C22 19.864 19.7614 22.1025 17 22.1025H7C4.23858 22.1025 2 19.864 2 17.1025V7.10254C2 4.34112 4.23858 2.10254 7 2.10254ZM16 11.4725C16.1234 12.3048 15.9813 13.1548 15.5938 13.9016C15.2063 14.6484 14.5931 15.254 13.8416 15.6322C13.0901 16.0105 12.2384 16.1421 11.4078 16.0085C10.5771 15.8748 9.80976 15.4826 9.21484 14.8877C8.61992 14.2928 8.22773 13.5254 8.09407 12.6948C7.9604 11.8641 8.09207 11.0124 8.47033 10.2609C8.84859 9.50939 9.45419 8.89628 10.201 8.50878C10.9478 8.12128 11.7978 7.97913 12.63 8.10254C13.4789 8.22842 14.2649 8.624 14.8717 9.23085C15.4785 9.83769 15.8741 10.6236 16 11.4725Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default Instagram;
